import React from 'react';

import {
  Image,
  Title,
  Text,
  Divider,
  ButtonGroup,
  Video } from
'./Blocks';


import { ModuleType } from '../types';



const renderModule = (type, descriptor) => {
  switch (type) {
    case ModuleType.IMAGE:
      return <Image {...descriptor} />;
    case ModuleType.TITLE:
      return <Title {...descriptor} />;
    case ModuleType.TEXT:
      return <Text {...descriptor} />;
    case ModuleType.VIDEO:
      return <Video {...descriptor} />;
    case ModuleType.DIVIDER:
      return <Divider {...descriptor} />;
    case ModuleType.BUTTON_GROUP:
      return <ButtonGroup {...descriptor} />;
    default:
      return null;
  }
};

const ColumnBuilder = (props) => {
  const { type, descriptor, isVisible = true } = props;

  if (!isVisible) {
    return null;
  }

  return (
    <>
      {renderModule(type, descriptor)}
    </>);

};

export default ColumnBuilder;